<template>
  <div v-if="show" class="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
    <div class="bg-white rounded-lg shadow-xl max-w-md w-full">
      <div class="p-6">
        <!-- 标题 -->
        <div class="text-center mb-4">
          <div class="w-16 h-16 bg-psychology-warning/10 rounded-full flex items-center justify-center mx-auto mb-3">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-8 h-8 text-psychology-warning">
              <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"></path>
              <path d="M12 9v4"></path>
              <path d="M12 17h.01"></path>
            </svg>
          </div>
          <h3 class="text-xl font-semibold text-gray-900 mb-2">检测到未完成的评估</h3>
          <p class="text-sm text-gray-600">
            检测到本地保存的未完成评估，已回答 <span class="font-semibold text-psychology-primary">{{ progressInfo.answeredCount }}</span> 道题。
            请选择继续作答或重新开始。
          </p>
        </div>

        <!-- 进度信息 -->
        <div class="bg-gray-50 rounded-lg p-4 mb-6">
          <div class="flex items-center justify-between mb-2">
            <span class="text-sm text-gray-600">测评类型</span>
            <span class="text-sm font-medium">
              {{ progressInfo.type === 'self' ? '给自己测' : '为恋人测' }}
            </span>
          </div>
          <div class="flex items-center justify-between mb-2">
            <span class="text-sm text-gray-600">答题进度</span>
            <span class="text-sm font-medium">{{ progressInfo.answeredCount }}/{{ progressInfo.totalQuestions }} 题</span>
          </div>
          <div class="w-full bg-gray-200 rounded-full h-2">
            <div 
              class="bg-psychology-primary h-2 rounded-full transition-all duration-300"
              :style="{ width: progressInfo.progress + '%' }"
            ></div>
          </div>
          <div class="text-xs text-gray-500 mt-1">
            开始时间：{{ formatTime(progressInfo.startTime) }}
          </div>
        </div>

        <!-- 按钮组 -->
        <div class="flex flex-col sm:flex-row gap-3">
          <button 
            @click="handleRestart"
            class="flex-1 px-4 py-2 border border-gray-300 bg-white hover:bg-gray-50 rounded-md transition-colors text-gray-700 font-medium"
          >
            重新开始
          </button>
          <button 
            @click="handleContinue"
            class="flex-1 px-4 py-2 bg-psychology-primary hover:bg-psychology-primary/90 text-white rounded-md transition-colors font-medium"
          >
            继续作答
          </button>
        </div>

        <!-- 提示信息 -->
        <div class="mt-4 text-xs text-gray-500 text-center">
          重新开始将清除当前进度，继续作答将恢复之前的答题状态
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IncompleteSessionDialog',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    progressInfo: {
      type: Object,
      required: true
    }
  },
  methods: {
    handleContinue() {
      this.$emit('continue')
    },
    handleRestart() {
      this.$emit('restart')
    },
    formatTime(timestamp) {
      if (!timestamp) return '未知'
      const date = new Date(timestamp)
      return date.toLocaleString('zh-CN', {
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      })
    }
  }
}
</script>
